import { TableCell } from '@toggle/design-system';
import { checkCellValueStyle } from '@toggle/helpers/src/utils/table/table';
import React from 'react';

import {
  formatNumberWithUnit,
  formatPercentageNumber,
} from '@/utils/asset/assetUtils';

export enum CellValueType {
  Currency,
  Percentage,
}

export interface ExpectationCellProps {
  value: number | '-' | '?';
  typeOfValue?: CellValueType;
}

export const ExpectationCell = ({
  value,
  typeOfValue = CellValueType.Currency,
  ...rest
}: ExpectationCellProps) => {
  if (value === '?' || value === '-') {
    return <TableCell>{value}</TableCell>;
  }

  return (
    <TableCell
      numericalValueStyle={checkCellValueStyle(value)}
      {...rest}
      suppressHydrationWarning
    >
      {typeOfValue === CellValueType.Percentage
        ? formatPercentageNumber(value)
        : formatNumberWithUnit(value)}
    </TableCell>
  );
};
